// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"592":"group-user","638":"group-admin"}[chunkId] || chunkId) + "." + {"475":"fdcb47c4","592":"b04271c1","638":"a41fd5e2"}[chunkId] + ".css";
};